var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okButtonProps: { class: { "jee-hidden": true } },
        okDisabled: true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { cancel: _vm.handleCancel, ok: _vm.handleOk }
    },
    [
      _c("apptype-application-list-form", {
        ref: "realForm",
        attrs: {
          appTypeName: this.appTypeName,
          appTypeId: this.appTypeId,
          entranceName: this.entranceName
        }
      }),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.language["common.closeButton"]))
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }